import React from "react";
import { Link } from "react-router-dom";
import {
  Coffee,
  MapPin,
  Mail,
  Phone,
  Instagram,
  Facebook,
  Twitter,
} from "lucide-react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <Coffee size={28} />
            <span>
              Brew <span className="amp">&</span> Co
            </span>
          </Link>
          <p>
            Premium Swiss coffee, sourced from the world's finest growing
            regions. Every cup tells a story.
          </p>
          <div className="footer-social">
            <a href="https://www.instagram.com/" aria-label="Instagram">
              <Instagram size={20} />
            </a>
            <a href="https://www.facebook.com/" aria-label="Facebook">
              <Facebook size={20} />
            </a>
            <a href="https://x.com/" aria-label="Twitter">
              <Twitter size={20} />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h4>Shop</h4>
          <Link to="/shop/espresso">Espresso</Link>
          <Link to="/shop/filter">Filter Coffee</Link>
          <Link to="/shop/cold-brew">Cold Brew</Link>
          <Link to="/shop/accessories">Accessories</Link>
          <Link to="/shop/gift-sets">Gift Sets</Link>
        </div>

        <div className="footer-links">
          <h4>Account</h4>
          <Link to="/login">Sign In</Link>
          <Link to="/register">Register</Link>
          <Link to="/orders">My Orders</Link>
          <Link to="/profile">Profile</Link>
        </div>

        <div className="footer-contact">
          <h4>Contact</h4>
          <p>
            <MapPin size={15} /> Bahnhofstrasse 42, 8001 Zürich
          </p>
          <p>
            <Mail size={15} /> hello@brewandco.ch
          </p>
          <p>
            <Phone size={15} /> +41 44 123 45 67
          </p>
          <div className="footer-payment">
            <span className="payment-badge">VISA</span>
            <span className="payment-badge">Mastercard</span>
            <span className="payment-badge twint-badge">TWINT</span>
            <span className="payment-badge">PostFinance</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom container">
        <p>
          © {new Date().getFullYear()} Brew & Co Switzerland. All rights
          reserved.
        </p>
        <div className="footer-legal">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
          <a href="#">Cookie Policy</a>
        </div>
      </div>
    </footer>
  );
}
